import { useTranslation } from 'react-i18next'
import { legalUrl } from '~/helpers/legal/legal-urls'

/**
 * Pied des écrans publics (#360) : les CGU et la politique de confidentialité, lisibles
 * avant de se connecter ou de créer un espace.
 */
function AuthLegalLinks() {
  const { t, i18n } = useTranslation()

  return (
    <nav aria-label={t('legal.links.label')} className="flex shrink-0 flex-wrap justify-end gap-x-4 gap-y-1 px-6 py-3 text-xs text-muted-foreground sm:px-10 lg:px-14">
      {(['TERMS_OF_USE', 'PRIVACY'] as const).map(page => (
        <a key={page} href={legalUrl(page, i18n.language)} target="_blank" rel="noopener noreferrer" className="underline-offset-2 hover:text-foreground hover:underline">
          {t(`legal.document.${page}`)}
          <span className="sr-only">{` ${t('legal.links.newTab')}`}</span>
        </a>
      ))}
    </nav>
  )
}

export default AuthLegalLinks
